
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface EditCodeDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  editingCode: {
    code: string;
    title: string | null;
  };
  onEditCodeChange: (value: { code: string; title: string | null }) => void;
  onSaveEdit: () => Promise<void>;
  isEditing: boolean;
}

export const EditCodeDialog = ({
  isOpen,
  onOpenChange,
  editingCode,
  onEditCodeChange,
  onSaveEdit,
  isEditing,
}: EditCodeDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Editar código</DialogTitle>
          <DialogDescription>
            Modifica el título del código {editingCode.code}.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Label htmlFor="code-title">Título</Label>
          <Input
            id="code-title"
            type="text"
            value={editingCode.title || ''}
            onChange={e => onEditCodeChange({ ...editingCode, title: e.target.value })}
            className="mt-2"
            placeholder="Título descriptivo (opcional)"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isEditing}>
            Cancelar
          </Button>
          <Button onClick={onSaveEdit} disabled={isEditing}>
            {isEditing ? "Guardando..." : "Guardar cambios"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
